import { ArrowRight, Rocket } from "lucide-react";
import { useLang } from "../LanguageContext";

export const FinalCta = ({ onCtaClick }) => {
  const { t } = useLang();

  return (
    <section id="final-cta" className="bg-[#E02020] py-16 sm:py-20">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center">
        <Rocket className="mx-auto mb-5 text-white" size={34} strokeWidth={1.7} />
        <p className="font-body text-xs font-bold uppercase tracking-[0.22em] text-white/70 mb-4">
          {t.finalCta.overline}
        </p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
          {t.finalCta.title}
        </h2>
        <p className="mt-5 text-white/80 text-base sm:text-lg leading-relaxed max-w-2xl mx-auto">
          {t.finalCta.text}
        </p>
        <button
          type="button"
          data-testid="final-cta"
          onClick={onCtaClick}
          className="mt-8 inline-flex items-center gap-2 bg-[#0A0A0A] hover:bg-[#1A1A1A] text-white font-medium text-base px-8 py-4 rounded-sm transition-colors"
        >
          {t.finalCta.cta} <ArrowRight size={18} />
        </button>
      </div>
    </section>
  );
};
